import apiReq from '../commontools/api.js'
export function GetSaleModuleValid(corpid){
	var url='/SaleModule/GetSaleModuleValid/'+corpid;
	return apiReq.get(url);
}
export function GetSaleModuleAll(corpid){
	var url='/SaleModule/GetSaleModuleAll/'+corpid;
	return apiReq.get(url);
}
export function AddSaleModule(info){
	var url='/SaleModule/AddSaleModule';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function EditSaleModule(info){
	var url='/SaleModule/EditSaleModule';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export default{
	GetSaleModuleValid,
	GetSaleModuleAll,
	AddSaleModule,
	EditSaleModule
}